/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Titlerequired1Inputs */

const id_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul wajib diisi`)
};

const ms_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tajuk diperlukan`)
};

const da_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel er påkrævet`)
};

const de_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel ist erforderlich`)
};

const en_us2_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title is required`)
};

const es_es2_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El título es obligatorio`)
};

const es_mx2_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El título es obligatorio`)
};

const fil_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinakailangan ang pamagat`)
};

const fr_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le titre est requis`)
};

const it_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il titolo è obbligatorio`)
};

const hu_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cím megadása kötelező`)
};

const nl_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel is verplicht`)
};

const no_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tittel er påkrevd`)
};

const pl_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuł jest wymagany`)
};

const pt_br2_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title is required`)
};

const pt_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O título é obrigatório`)
};

const ro_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titlul este obligatoriu`)
};

const fi_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otsikko vaaditaan`)
};

const sv_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel krävs`)
};

const vi_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề là bắt buộc`)
};

const tr_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlık zorunludur`)
};

const cs_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název je povinný`)
};

const bg_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заглавието е задължително`)
};

const ru_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок обязателен`)
};

const uk_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок обов'язковий`)
};

const ar_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنوان مطلوب`)
};

const hi_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक आवश्यक`)
};

const th_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จำเป็นต้องมีชื่อเรื่อง`)
};

const ja_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトルは必須です`)
};

const zh_cn2_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title is required`)
};

const zh_hant1_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title is required`)
};

const ko_forms_review_titlerequired1 = /** @type {(inputs: Forms_Review_Titlerequired1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title is required`)
};

/**
* | output |
* | --- |
* | "Title is required" |
*
* @param {Forms_Review_Titlerequired1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_titlerequired1 = /** @type {((inputs?: Forms_Review_Titlerequired1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Titlerequired1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_titlerequired1(inputs)
	if (locale === "ms") return ms_forms_review_titlerequired1(inputs)
	if (locale === "da") return da_forms_review_titlerequired1(inputs)
	if (locale === "de") return de_forms_review_titlerequired1(inputs)
	if (locale === "en-US") return en_us2_forms_review_titlerequired1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_titlerequired1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_titlerequired1(inputs)
	if (locale === "fil") return fil_forms_review_titlerequired1(inputs)
	if (locale === "fr") return fr_forms_review_titlerequired1(inputs)
	if (locale === "it") return it_forms_review_titlerequired1(inputs)
	if (locale === "hu") return hu_forms_review_titlerequired1(inputs)
	if (locale === "nl") return nl_forms_review_titlerequired1(inputs)
	if (locale === "no") return no_forms_review_titlerequired1(inputs)
	if (locale === "pl") return pl_forms_review_titlerequired1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_titlerequired1(inputs)
	if (locale === "pt") return pt_forms_review_titlerequired1(inputs)
	if (locale === "ro") return ro_forms_review_titlerequired1(inputs)
	if (locale === "fi") return fi_forms_review_titlerequired1(inputs)
	if (locale === "sv") return sv_forms_review_titlerequired1(inputs)
	if (locale === "vi") return vi_forms_review_titlerequired1(inputs)
	if (locale === "tr") return tr_forms_review_titlerequired1(inputs)
	if (locale === "cs") return cs_forms_review_titlerequired1(inputs)
	if (locale === "bg") return bg_forms_review_titlerequired1(inputs)
	if (locale === "ru") return ru_forms_review_titlerequired1(inputs)
	if (locale === "uk") return uk_forms_review_titlerequired1(inputs)
	if (locale === "ar") return ar_forms_review_titlerequired1(inputs)
	if (locale === "hi") return hi_forms_review_titlerequired1(inputs)
	if (locale === "th") return th_forms_review_titlerequired1(inputs)
	if (locale === "ja") return ja_forms_review_titlerequired1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_titlerequired1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_titlerequired1(inputs)
	return ko_forms_review_titlerequired1(inputs)
});
export { forms_review_titlerequired1 as "forms.review.titleRequired" }